import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { systemConfigAPI } from '../services/api';

const MailingContext = createContext({
  mailingEnabled: false,
  mailingStatusLoading: true,
  refreshMailingStatus: async () => {}
});

export const MailingProvider = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const [mailingEnabled, setMailingEnabled] = useState(false);
  const [mailingStatusLoading, setMailingStatusLoading] = useState(true);

  const refreshMailingStatus = useCallback(async () => {
    if (!user) {
      setMailingEnabled(false);
      setMailingStatusLoading(false);
      return;
    }
    try {
      setMailingStatusLoading(true);
      const res = await systemConfigAPI.getMailingStatus();
      setMailingEnabled(Boolean(res?.data?.enabled));
    } catch {
      setMailingEnabled(false);
    } finally {
      setMailingStatusLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (authLoading) {
      return;
    }
    refreshMailingStatus();
  }, [authLoading, user?.id, refreshMailingStatus]);

  return (
    <MailingContext.Provider value={{ mailingEnabled, mailingStatusLoading, refreshMailingStatus }}>
      {children}
    </MailingContext.Provider>
  );
};

export const useMailing = () => useContext(MailingContext);
